import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=bdaa2026&scoped=true"
import script from "./changePhone.vue?vue&type=script&lang=js"
export * from "./changePhone.vue?vue&type=script&lang=js"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=bdaa2026&prod&lang=less&scoped=true"
import style1 from "./changePhone.vue?vue&type=style&index=1&id=bdaa2026&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaa2026",
  null
  
)

export default component.exports